import { Trans } from 'react-i18next'

import greatJobPNG from '~/assets/images/history/history-great-job.png'
import greatJobWEBP from '~/assets/images/history/history-great-job.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const GreatJob = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Great job',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={greatJobWEBP} type="image/webp" />
            <img src={greatJobPNG} alt="Great job" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="history" i18nKey="onboarding.historyGreatJob.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="history" i18nKey="onboarding.historyGreatJob.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default GreatJob
